import type { UTMAttrs } from '@/types';

const DOUBLECLICK_URL_PREFIX = 'https://ad.doubleclick.net';

export const evaluateAndAppendUTMParams = (url?: string, params?: UTMAttrs) => {
  if (!url) {
    return url;
  }

  try {
    const { utmCampaign, utmMedium, utmSource, utmParamsEnabled } = params || {};

    if (!utmParamsEnabled) {
      return url;
    }

    if (url.includes('{{') || url.includes('}}')) {
      return url;
    }

    if (url.includes('utm_')) {
      return url;
    }

    if (url.startsWith(DOUBLECLICK_URL_PREFIX)) {
      return url;
    }

    if (url.startsWith(document.location.origin)) {
      return url;
    }

    // Ad opportunity URLs are not supposed to have UTM params
    if (url.includes('_bhiiv')) {
      return url;
    }

    const urlObj = new URL(url);

    if (!urlObj.protocol.startsWith('http')) {
      return url;
    }

    if (utmCampaign) {
      urlObj.searchParams.append('utm_campaign', utmCampaign);
    }
    if (utmMedium) {
      urlObj.searchParams.append('utm_medium', utmMedium);
    }
    if (utmSource) {
      urlObj.searchParams.append('utm_source', utmSource);
    }

    return urlObj.toString();
  } catch (_error: unknown) {
    return url;
  }
};
